import { Outlet, useLocation } from 'react-router-dom';
import { AppSidebar } from '../../components/blocks/layout/app-sidebar';
import { UProfileMenu } from '../../components/blocks/u-profile-menu';
import { SidebarTrigger, useSidebar } from 'components/ui/sidebar';
import { DynamicHeader } from './header/components/DynamicHeader';
import { ModelSelector } from '../../components/blocks/model-selector';
import { hasValidConversationComponentRoute } from 'pages/services/utilityService';
import { AppFooter } from 'components/blocks/layout/app-footer';

export enum SidebarHeaderVariant {
  Logo = 'logo',
  Icons = 'icons',
}

export interface SidebarHeaderConfig {
  type: SidebarHeaderVariant;
  logo?: string;
  smallLogo?: string;
  open?: boolean;
  isMobile?: boolean;
  setOpenMobile?: (open: boolean) => void;
  strokeWidth?: number;
  toggleSidebar?: () => void;
  onNewChatClick?: () => void;
}

export default function MainLayout() {
  const { open, isMobile, toggleSidebar } = useSidebar();
  const { pathname } = useLocation();
  const segments = pathname?.split('/').filter(Boolean);
  const firstSegment = segments?.[0] ?? undefined;
  const isEmailRoute = firstSegment === 'mail';

  return (
    <div className="flex w-full min-h-screen relative">
      <div className="absolute left-0 top-0 h-full">
        <AppSidebar
          type={SidebarHeaderVariant.Icons}
          strokeWidth={2}
          toggleSidebar={toggleSidebar}
        />
      </div>

      <div
        className={`flex flex-col w-full h-full ${isMobile ? 'ml-0' : open ? 'ml-[var(--sidebar-width)]' : 'ml-0'
          } transition-[margin-left] duration-300 ease-in-out`}
      >
        <div className="sticky bg-card z-20 top-0 border-b py-2 xs:px-2 sm:px-6 md:px-8 flex justify-between items-center w-full">
          <div className="flex items-center">
            <SidebarTrigger className="mr-1" />
            {hasValidConversationComponentRoute(pathname) && <ModelSelector />}
          </div>
          <div className="flex justify-between items-center gap-1 sm:gap-3 md:gap-4">
            <DynamicHeader />
            <div className="border-l border-gray-300 h-4"></div>
            <UProfileMenu isDropdownIconRequired={!isMobile} isFullNameRequired={!isMobile} />
          </div>
        </div>
        <div
          className={`flex h-full ${!isEmailRoute && 'p-4 sm:p-6 md:p-8'} ${open && !isMobile ? 'w-[calc(100vw-var(--sidebar-width))]' : 'w-full'}`}
        >
          <Outlet />
        </div>
        <AppFooter />
      </div>
    </div>
  );
}
